export default "__VITE_ASSET__3f1ebbd4__"